var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-parameter-form" },
    [
      _c("div", { staticClass: "params-header" }, [
        _c("div", { staticClass: "params-header__left" }, [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.mode === "appointment" ? "团购预约日期参数" : "酒店日期参数"
              )
            ),
          ]),
          _vm._v(" "),
          _vm.rangeSummary
            ? _c("span", { staticClass: "params-header__summary" }, [
                _vm._v(_vm._s(_vm.rangeSummary)),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-panel" },
        [
          _vm.mode === "hotel"
            ? _c(
                "el-form",
                {
                  key: "hotel-date-form",
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    "label-position": "right",
                    "label-width": "140px",
                    rules: _vm.hotelRules,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "form-row hotel-rule-row",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "入店时间：",
                                prop: "hotelCheckInTime",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "time-field" },
                                [
                                  _c("el-time-picker", {
                                    staticClass: "field-control",
                                    attrs: {
                                      "value-format": "HH:mm",
                                      format: "HH:mm",
                                      placeholder: "选择时间",
                                    },
                                    model: {
                                      value: _vm.form.hotelCheckInTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "hotelCheckInTime",
                                          $$v
                                        )
                                      },
                                      expression: "form.hotelCheckInTime",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time-suffix" }, [
                                    _vm._v("之后"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "离店时间：",
                                prop: "hotelCheckOutTime",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "time-field" },
                                [
                                  _c("el-time-picker", {
                                    staticClass: "field-control",
                                    attrs: {
                                      "value-format": "HH:mm",
                                      format: "HH:mm",
                                      placeholder: "选择时间",
                                    },
                                    model: {
                                      value: _vm.form.hotelCheckOutTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "hotelCheckOutTime",
                                          $$v
                                        )
                                      },
                                      expression: "form.hotelCheckOutTime",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time-suffix" }, [
                                    _vm._v("之前"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "当日预订截止时间：",
                                prop: "deadlineTime",
                              },
                            },
                            [
                              _c("el-time-picker", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  "value-format": "HH:mm",
                                  format: "HH:mm",
                                  placeholder: "选择时间",
                                },
                                model: {
                                  value: _vm.form.deadlineTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "deadlineTime", $$v)
                                  },
                                  expression: "form.deadlineTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.mode !== "hotel"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "customer-cancel-form-item",
                                  attrs: { prop: "customerCancelDays" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "form-item-label",
                                      attrs: { slot: "label" },
                                      slot: "label",
                                    },
                                    [
                                      _vm._v(
                                        "\n            客户可取消时间\n            "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "在此时间前用户可自主取消订单，取消后系统自动全额原路退款",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question field-tip",
                                          }),
                                        ]
                                      ),
                                      _vm._v("\n            ：\n          "),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "customer-cancel-inline" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "customer-cancel-inline__text",
                                        },
                                        [_vm._v("入住前")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        staticClass:
                                          "customer-cancel-inline__days",
                                        attrs: {
                                          placeholder: "请输入天数",
                                          type: "number",
                                          min: 0,
                                        },
                                        on: {
                                          input:
                                            _vm.handleCustomerCancelDaysInput,
                                        },
                                        model: {
                                          value: _vm.form.customerCancelDays,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "customerCancelDays",
                                              $$v
                                            )
                                          },
                                          expression: "form.customerCancelDays",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "customer-cancel-inline__text",
                                        },
                                        [_vm._v("天")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-time-picker", {
                                        staticClass:
                                          "customer-cancel-inline__time",
                                        attrs: {
                                          "value-format": "HH:mm",
                                          format: "HH:mm",
                                          placeholder: "选择时间",
                                        },
                                        on: {
                                          change:
                                            _vm.handleCustomerCancelTimeChange,
                                        },
                                        model: {
                                          value: _vm.form.customerCancelTime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "customerCancelTime",
                                              $$v
                                            )
                                          },
                                          expression: "form.customerCancelTime",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "customer-cancel-inline__text",
                                        },
                                        [_vm._v("前")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mode === "hotel"
                    ? _c("div", { staticClass: "hotel-refund-section" }, [
                        _c("div", { staticClass: "hotel-refund-header" }, [
                          _c(
                            "span",
                            { staticClass: "section-title" },
                            [
                              _c("span", { staticClass: "required-mark" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v("取消订单商品退款配置\n          "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "修改配置后，用户取消订单优先以商品配置退款",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hotel-refund-header-actions" },
                            [
                              _c(
                                "div",
                                { staticClass: "sync-store-config" },
                                [
                                  _c("span", [_vm._v("是否同步店铺配置：")]),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change:
                                          _vm.handleSyncStoreRefundConfigChange,
                                      },
                                      model: {
                                        value: _vm.form.syncStoreRefundConfig,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "syncStoreRefundConfig",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.syncStoreRefundConfig",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("是"),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("否"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    size: "small",
                                    icon: "el-icon-refresh",
                                  },
                                  on: {
                                    click: _vm.handleResetHotelRefundConfigs,
                                  },
                                },
                                [_vm._v("恢复默认")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.form.hotelRefundConfigs.length
                          ? _c(
                              "div",
                              { staticClass: "hotel-refund-table" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hotel-refund-row header-row",
                                  },
                                  [
                                    _c("span", { staticClass: "col-label" }, [
                                      _vm._v("距离入住时间"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "col-action" }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "hotel-refund-row" }, [
                                  _c(
                                    "span",
                                    { staticClass: "row-text" },
                                    [
                                      _vm._v(
                                        "\n            超过 \n            "
                                      ),
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          precision: 0,
                                          step: 1,
                                          size: "small",
                                          "controls-position": "right",
                                          disabled:
                                            _vm.form.hotelRefundConfigs.length >
                                            1,
                                        },
                                        on: {
                                          change: function (val) {
                                            return _vm.handleRefundStartHourChange(
                                              0,
                                              val
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.form.hotelRefundConfigs[0]
                                              .startHour,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.hotelRefundConfigs[0],
                                              "startHour",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.hotelRefundConfigs[0].startHour",
                                        },
                                      }),
                                      _vm._v(" 小时，退款比例\n          "),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "refund-input" },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: 100,
                                          disabled: true,
                                          size: "small",
                                          "controls-position": "right",
                                        },
                                        model: {
                                          value:
                                            _vm.form.hotelRefundConfigs[0]
                                              .refundRate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.hotelRefundConfigs[0],
                                              "refundRate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.hotelRefundConfigs[0].refundRate",
                                        },
                                      }),
                                      _vm._v(" %\n          "),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "col-action" }, [
                                    _vm.form.hotelRefundConfigs.length === 1
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-circle-plus-outline action-icon",
                                          on: { click: _vm.handleAddRefundRow },
                                        })
                                      : _vm._e(),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.form.hotelRefundConfigs.slice(1),
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "hotel-refund-row",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "row-text" },
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                min: 1,
                                                max: Number(item.endHour) - 1,
                                                precision: 0,
                                                step: 1,
                                                size: "small",
                                                "controls-position": "right",
                                                disabled:
                                                  index !==
                                                  _vm.form.hotelRefundConfigs
                                                    .length -
                                                    2,
                                              },
                                              on: {
                                                change: function (val) {
                                                  return _vm.handleRefundStartHourChange(
                                                    index + 1,
                                                    val
                                                  )
                                                },
                                              },
                                              model: {
                                                value: item.startHour,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "startHour",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.startHour",
                                              },
                                            }),
                                            _vm._v(" ~\n            "),
                                            _c("el-input-number", {
                                              attrs: {
                                                precision: 0,
                                                step: 1,
                                                size: "small",
                                                "controls-position": "right",
                                                disabled: true,
                                              },
                                              model: {
                                                value: item.endHour,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "endHour", $$v)
                                                },
                                                expression: "item.endHour",
                                              },
                                            }),
                                            _vm._v(
                                              " 小时，退款比例\n          "
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "refund-input" },
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                min: 1,
                                                max: 100,
                                                precision: 0,
                                                step: 1,
                                                size: "small",
                                                "controls-position": "right",
                                              },
                                              on: {
                                                change:
                                                  _vm.handleHotelRefundConfigManualChange,
                                              },
                                              model: {
                                                value: item.refundRate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "refundRate",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.refundRate",
                                              },
                                            }),
                                            _vm._v(" %\n          "),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "col-action" },
                                          [
                                            index ===
                                            _vm.form.hotelRefundConfigs.length -
                                              2
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-remove-outline action-icon",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleRemoveRefundRow(
                                                        index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index ===
                                            _vm.form.hotelRefundConfigs.length -
                                              2
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-plus-outline action-icon",
                                                  on: {
                                                    click:
                                                      _vm.handleAddRefundRow,
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "hotel-refund-row limit-row" },
                                  [
                                    _c("span", { staticClass: "row-text" }, [
                                      _vm._v(
                                        "\n            距离入住时间 \n            "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "time-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.hotelRefundCancelLimitHour
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " 小时以内，订单无法取消\n          "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "col-action" }),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _c(
                              "div",
                              { staticClass: "hotel-refund-empty" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: { click: _vm.handleAddRefundRow },
                                  },
                                  [_vm._v("新增退款规则")]
                                ),
                              ],
                              1
                            ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "form-row form-row--base",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "日期范围：", prop: "dateRange" },
                            },
                            [
                              _c("el-date-picker", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd",
                                  "picker-options": _vm.datePickerOptions,
                                },
                                model: {
                                  value: _vm.form.dateRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "dateRange", $$v)
                                  },
                                  expression: "form.dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "客房单价：¥", prop: "price" } },
                            [
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入单价",
                                  type: "number",
                                  min: 0,
                                },
                                model: {
                                  value: _vm.form.price,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "price", $$v)
                                  },
                                  expression: "form.price",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "客房成本价：¥",
                                prop: "costPrice",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入成本价",
                                  type: "number",
                                  min: 0,
                                },
                                model: {
                                  value: _vm.form.costPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "costPrice", $$v)
                                  },
                                  expression: "form.costPrice",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "每天库存：", prop: "stock" } },
                            [
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入库存",
                                  type: "number",
                                  min: 0,
                                },
                                model: {
                                  value: _vm.form.stock,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "stock", $$v)
                                  },
                                  expression: "form.stock",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "form-row form-row--stock-warning" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "stock-warning-item",
                              attrs: { "label-width": "140px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "form-item-label",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [
                                  _vm._v(
                                    "\n            库存预警\n            "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "低于该库存将通知店铺绑定的微信号/手机号",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-question field-tip",
                                      }),
                                    ]
                                  ),
                                  _vm._v("\n            ：\n          "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass:
                                  "field-control stock-warning-input",
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "6",
                                  type: "number",
                                  min: "0",
                                  oninput:
                                    "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                                },
                                model: {
                                  value: _vm.localStockWarning,
                                  callback: function ($$v) {
                                    _vm.localStockWarning = $$v
                                  },
                                  expression: "localStockWarning",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "appointment"
            ? _c(
                "el-form",
                {
                  key: "appointment-date-form",
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    "label-position": "right",
                    "label-width": "140px",
                    rules: _vm.appointmentRules,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticClass:
                        "form-row form-row--rule appointment-rule-row",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "rule-form-item rule-form-item--compact",
                              attrs: {
                                label: "当日预订截止时间：",
                                prop: "deadlineTime",
                              },
                            },
                            [
                              _c("el-time-picker", {
                                staticClass: "rule-time-picker",
                                attrs: {
                                  "value-format": "HH:mm",
                                  format: "HH:mm",
                                  placeholder: "选择时间",
                                },
                                model: {
                                  value: _vm.form.deadlineTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "deadlineTime", $$v)
                                  },
                                  expression: "form.deadlineTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "appointment-refund-col",
                          attrs: { span: 10 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "rule-form-item refund-form-item",
                              attrs: {
                                prop: "refundDays",
                                "label-width": "108px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "form-item-label",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [
                                  _vm._v(
                                    "\n            可退款时间\n            "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "用户在预约日期前指定天数和时间之前可申请退款",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-question field-tip",
                                      }),
                                    ]
                                  ),
                                  _vm._v("\n            ：\n          "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "refund-inline" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "refund-inline__text" },
                                    [_vm._v("预约日期前")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticClass: "refund-inline__days",
                                    attrs: {
                                      placeholder: "请输入天数",
                                      type: "number",
                                      min: 0,
                                    },
                                    model: {
                                      value: _vm.form.refundDays,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "refundDays", $$v)
                                      },
                                      expression: "form.refundDays",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "refund-inline__text" },
                                    [_vm._v("天")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-time-picker", {
                                    staticClass: "refund-inline__time",
                                    attrs: {
                                      "value-format": "HH:mm",
                                      format: "HH:mm",
                                      placeholder: "选择时间",
                                    },
                                    on: { change: _vm.handleRefundTimeChange },
                                    model: {
                                      value: _vm.form.refundTime,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "refundTime", $$v)
                                      },
                                      expression: "form.refundTime",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "refund-inline__text" },
                                    [_vm._v("前")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "rule-form-item rule-form-item--compact",
                              attrs: {
                                label: "订单超时未核销是否自动退：",
                                prop: "timeoutAutoRefundFlag",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.timeoutAutoRefundFlag,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "timeoutAutoRefundFlag",
                                        $$v
                                      )
                                    },
                                    expression: "form.timeoutAutoRefundFlag",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "form-row form-row--base",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "日期范围：", prop: "dateRange" },
                            },
                            [
                              _c("el-date-picker", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd",
                                  "picker-options": _vm.datePickerOptions,
                                },
                                model: {
                                  value: _vm.form.dateRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "dateRange", $$v)
                                  },
                                  expression: "form.dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品单价：¥", prop: "price" } },
                            [
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入单价",
                                  type: "number",
                                  min: 0,
                                },
                                model: {
                                  value: _vm.form.price,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "price", $$v)
                                  },
                                  expression: "form.price",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品成本价：¥",
                                prop: "costPrice",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入成本价",
                                  type: "number",
                                  min: 0,
                                },
                                model: {
                                  value: _vm.form.costPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "costPrice", $$v)
                                  },
                                  expression: "form.costPrice",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "每天库存：", prop: "stock" } },
                            [
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入",
                                  type: "number",
                                  min: 0,
                                },
                                model: {
                                  value: _vm.form.stock,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "stock", $$v)
                                  },
                                  expression: "form.stock",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "form-row form-row--purchase-limit",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "minQuantity" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "form-item-label",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [
                                  _vm._v(
                                    "\n            起购数量\n            "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "单笔订单最少购买份数，不足则无法下单",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-question field-tip",
                                      }),
                                    ]
                                  ),
                                  _vm._v("\n            ：\n          "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "6",
                                  type: "number",
                                  min: "1",
                                  oninput:
                                    "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<1||value.indexOf('-')!==-1)value=''",
                                },
                                model: {
                                  value: _vm.form.minQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "minQuantity", $$v)
                                  },
                                  expression: "form.minQuantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "maxQuantity" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "form-item-label",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [
                                  _vm._v(
                                    "\n            限购数量\n            "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "用户单次最多可购份数，超出无法下单",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-question field-tip",
                                      }),
                                    ]
                                  ),
                                  _vm._v("\n            ：\n          "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "6",
                                  type: "number",
                                  min: "1",
                                  oninput:
                                    "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<1||value.indexOf('-')!==-1)value=''",
                                },
                                model: {
                                  value: _vm.form.maxQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "maxQuantity", $$v)
                                  },
                                  expression: "form.maxQuantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "form-item-label",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [
                                  _vm._v(
                                    "\n            库存预警\n            "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "低于该库存将通知店铺绑定的微信号/手机号",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-question field-tip",
                                      }),
                                    ]
                                  ),
                                  _vm._v("\n            ：\n          "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass:
                                  "field-control field-control--full",
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "6",
                                  type: "number",
                                  min: "0",
                                  oninput:
                                    "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                                },
                                model: {
                                  value: _vm.localStockWarning,
                                  callback: function ($$v) {
                                    _vm.localStockWarning = $$v
                                  },
                                  expression: "localStockWarning",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.dateRange && _vm.form.dateRange.length === 2
        ? _c("div", { staticClass: "calendar-container" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "price-calendar-wrapper" },
              [
                _c("div", { staticClass: "calendar-nav-bar" }, [
                  _c(
                    "div",
                    { staticClass: "calendar-nav-bar__left" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            disabled: !_vm.canOpenRangePrice,
                          },
                          on: { click: _vm.rangePrice },
                        },
                        [_vm._v("\n            范围变价\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "calendar-nav-bar__title" }, [
                    _vm._v(_vm._s(_vm.calendarTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "calendar-nav-bar__actions" },
                    [
                      _c(
                        "el-button-group",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.goPrevMonth },
                            },
                            [_vm._v("上个月")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.goToday },
                            },
                            [_vm._v("今天")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.goNextMonth },
                            },
                            [_vm._v("下个月")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-calendar", {
                  staticClass: "price-calendar",
                  class: {
                    "price-calendar--appointment": _vm.mode === "appointment",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "dateCell",
                        fn: function (ref) {
                          var data = ref.data
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "calendar-day",
                                class: _vm.getCalendarDayClass(data.day),
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDayClick(data.day)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "day-number" }, [
                                  _vm._v(
                                    _vm._s(
                                      data.day.split("-").slice(2).join("-")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "day-weekday" }, [
                                  _vm._v(_vm._s(_vm.getWeekday(data.day))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "day-price" },
                                  [
                                    _vm.isDateInRange(data.day)
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "day-meta" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "day-meta__price",
                                                },
                                                [
                                                  _vm._v(
                                                    "单价 ¥" +
                                                      _vm._s(
                                                        _vm.formatDisplayPrice(
                                                          _vm.getDatePrice(
                                                            data.day
                                                          )
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "day-meta__cost",
                                                },
                                                [
                                                  _vm._v(
                                                    "成本 ¥" +
                                                      _vm._s(
                                                        _vm.formatDisplayPrice(
                                                          _vm.getDateCostPrice(
                                                            data.day
                                                          )
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "day-meta__stock",
                                                },
                                                [
                                                  _vm._v(
                                                    "库存 " +
                                                      _vm._s(
                                                        _vm.getDateStock(
                                                          data.day
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "day-price__placeholder",
                                            },
                                            [_vm._v("—")]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    568078105
                  ),
                  model: {
                    value: _vm.currentDate,
                    callback: function ($$v) {
                      _vm.currentDate = $$v
                    },
                    expression: "currentDate",
                  },
                }),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "calendar-empty" }, [
            _c("i", { staticClass: "el-icon-date" }),
            _vm._v(" "),
            _c("p", [_vm._v("请先选择日期范围，系统将自动生成价格日历")]),
          ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.mode === "appointment" ? "范围变价" : "变价",
            visible: _vm.rangeDialogVisible,
            width: "1200px",
            top: "6vh",
            "close-on-click-modal": false,
            "custom-class":
              _vm.mode === "appointment"
                ? "range-dialog range-dialog--appointment"
                : "range-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rangeDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "range-dialog-content" }, [
            _c(
              "section",
              { staticClass: "range-batch-panel" },
              [
                _c("header", { staticClass: "range-section-head" }, [
                  _c("span", { staticClass: "range-section-head__title" }, [
                    _vm._v("批量设置"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "range-section-head__desc" }, [
                    _vm._v("填写固定值后，可一键应用到所选范围或周末"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    staticClass: "range-form",
                    attrs: { model: _vm.rangeForm, "label-width": "0" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "range-batch-date" },
                      [
                        _c(
                          "label",
                          { staticClass: "range-batch-date__label" },
                          [_vm._v("日期范围")]
                        ),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticClass: "range-batch-date__picker",
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            format: "yyyy-MM-dd",
                            "picker-options": _vm.rangeDialogPickerOptions,
                          },
                          on: { change: _vm.onRangeDateChange },
                          model: {
                            value: _vm.rangeForm.dateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.rangeForm, "dateRange", $$v)
                            },
                            expression: "rangeForm.dateRange",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "range-batch-grid",
                        class: {
                          "range-batch-grid--dual": _vm.mode !== "appointment",
                          "range-batch-grid--triple":
                            _vm.mode === "appointment",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "range-batch-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "range-batch-card__head" },
                              [
                                _c("i", { staticClass: "el-icon-coin" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.mode === "appointment"
                                        ? "固定价格"
                                        : "固定房价"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "range-batch-card__input",
                              attrs: {
                                size: "small",
                                type: "number",
                                min: 0,
                                placeholder: "请输入价格",
                              },
                              model: {
                                value: _vm.rangeForm.basePrice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rangeForm, "basePrice", $$v)
                                },
                                expression: "rangeForm.basePrice",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "range-batch-card__actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: { click: _vm.applyBasePriceToRange },
                                  },
                                  [_vm._v("应用到范围")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "warning", size: "mini" },
                                    on: { click: _vm.applyBasePriceToWeekend },
                                  },
                                  [_vm._v("应用到周末")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "range-batch-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "range-batch-card__head" },
                              [
                                _c("i", { staticClass: "el-icon-money" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("固定成本价")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "range-batch-card__input",
                              attrs: {
                                size: "small",
                                type: "number",
                                min: 0,
                                placeholder: "请输入成本价",
                              },
                              model: {
                                value: _vm.rangeForm.baseCostPrice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rangeForm, "baseCostPrice", $$v)
                                },
                                expression: "rangeForm.baseCostPrice",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "range-batch-card__actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: _vm.applyBaseCostPriceToRange,
                                    },
                                  },
                                  [_vm._v("应用到范围")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "warning", size: "mini" },
                                    on: {
                                      click: _vm.applyBaseCostPriceToWeekend,
                                    },
                                  },
                                  [_vm._v("应用到周末")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.mode === "appointment"
                          ? _c(
                              "div",
                              { staticClass: "range-batch-card" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "range-batch-card__head" },
                                  [
                                    _c("i", { staticClass: "el-icon-box" }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("固定库存")]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "range-batch-card__input",
                                  attrs: {
                                    size: "small",
                                    type: "number",
                                    min: 0,
                                    placeholder: "请输入库存",
                                  },
                                  model: {
                                    value: _vm.rangeForm.baseStock,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.rangeForm, "baseStock", $$v)
                                    },
                                    expression: "rangeForm.baseStock",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "range-batch-card__actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: {
                                          click: _vm.applyBaseStockToRange,
                                        },
                                      },
                                      [_vm._v("应用到范围")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "warning",
                                          size: "mini",
                                        },
                                        on: {
                                          click: _vm.applyBaseStockToWeekend,
                                        },
                                      },
                                      [_vm._v("应用到周末")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "range-daily-panel" }, [
              _c("header", { staticClass: "range-section-head" }, [
                _c("span", { staticClass: "range-section-head__title" }, [
                  _vm._v("逐日调整"),
                ]),
                _vm._v(" "),
                _vm.rangeItems.length
                  ? _c("span", { staticClass: "range-section-head__meta" }, [
                      _vm._v("共 " + _vm._s(_vm.rangeItems.length) + " 天"),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.rangeItems.length
                ? _c("div", { staticClass: "range-calendar" }, [
                    _c(
                      "div",
                      { staticClass: "range-calendar__weekdays" },
                      _vm._l(_vm.weekdayHeaders, function (label) {
                        return _c(
                          "span",
                          {
                            key: label,
                            staticClass: "range-calendar__weekday",
                            class: {
                              "is-weekend":
                                label === "周六" || label === "周日",
                            },
                          },
                          [_vm._v(_vm._s(label))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "range-items range-items--calendar" },
                      _vm._l(_vm.rangeCalendarCells, function (cell) {
                        return _c(
                          "div",
                          {
                            key: cell.key,
                            staticClass: "range-item",
                            class: {
                              "range-item--empty": cell.type === "empty",
                              "is-weekend":
                                cell.type === "item" &&
                                (cell.weekDay === "周六" ||
                                  cell.weekDay === "周日"),
                            },
                          },
                          [
                            cell.type === "item"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "range-item__head" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "range-item__date" },
                                        [
                                          _vm._v(
                                            _vm._s(cell.expireDate.slice(5))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "range-item__weekday" },
                                        [_vm._v(_vm._s(cell.weekDay))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "range-item-inputs" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "range-field-input" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "range-field-label range-field-label--price",
                                            },
                                            [_vm._v("单价")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            attrs: {
                                              size: "small",
                                              type: "number",
                                              min: 0,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.syncEditablePrices()
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.form.attrValue[cell.idx]
                                                  .price,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.attrValue[cell.idx],
                                                  "price",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.attrValue[cell.idx].price",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "range-field-input" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "range-field-label range-field-label--cost",
                                            },
                                            [_vm._v("成本")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            attrs: {
                                              size: "small",
                                              type: "number",
                                              min: 0,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.syncEditablePrices()
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.form.attrValue[cell.idx]
                                                  .costPrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.attrValue[cell.idx],
                                                  "costPrice",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.attrValue[cell.idx].costPrice",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.mode === "appointment"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "range-field-input",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "range-field-label",
                                                },
                                                [_vm._v("库存")]
                                              ),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                attrs: {
                                                  size: "small",
                                                  type: "number",
                                                  min: 0,
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.attrValue[cell.idx]
                                                      .stock,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.attrValue[
                                                        cell.idx
                                                      ],
                                                      "stock",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.attrValue[cell.idx].stock",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _c("div", { staticClass: "range-items-empty" }, [
                    _c("i", { staticClass: "el-icon-date" }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("请先选择日期范围，系统将生成可编辑的日期列表"),
                    ]),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "range-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("span", { staticClass: "range-dialog-footer__hint" }, [
                _vm._v("保存后将同步更新至价格日历"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "range-dialog-footer__actions" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.rangeDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitRangePrice },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "day-edit-dialog",
          attrs: {
            title: "编辑日期",
            visible: _vm.dayDialogVisible,
            width: "420px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dayDialogVisible = $event
            },
            closed: _vm.resetDayForm,
          },
        },
        [
          _c("div", { staticClass: "day-dialog-date" }, [
            _vm._v(
              _vm._s(_vm.dayForm.expireDate) +
                "（" +
                _vm._s(_vm.dayForm.weekDay) +
                "）"
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "dayFormRef",
              attrs: {
                model: _vm.dayForm,
                rules: _vm.dayFormRules,
                "label-width": "72px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "价格", prop: "price" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        type: "number",
                        min: 0,
                        placeholder: "请输入价格",
                      },
                      model: {
                        value: _vm.dayForm.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.dayForm, "price", $$v)
                        },
                        expression: "dayForm.price",
                      },
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("¥")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "成本价", prop: "costPrice" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        type: "number",
                        min: 0,
                        placeholder: "请输入成本价",
                      },
                      model: {
                        value: _vm.dayForm.costPrice,
                        callback: function ($$v) {
                          _vm.$set(_vm.dayForm, "costPrice", $$v)
                        },
                        expression: "dayForm.costPrice",
                      },
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("¥")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "库存", prop: "stock" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      min: 0,
                      placeholder: "请输入库存",
                    },
                    model: {
                      value: _vm.dayForm.stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.dayForm, "stock", $$v)
                      },
                      expression: "dayForm.stock",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dayDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitDayEdit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "calendar-toolbar" }, [
      _c("div", { staticClass: "calendar-toolbar__info" }, [
        _c("span", { staticClass: "calendar-toolbar__label" }, [
          _vm._v("价格日历"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "calendar-toolbar__hint" }, [
          _vm._v("\n          点击日期可单独修改价格、成本价和库存\n        "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calendar-legend" }, [
        _c("span", { staticClass: "legend-item legend-item--active" }, [
          _c("i"),
          _vm._v("可售日期"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "legend-item legend-item--weekend" }, [
          _c("i"),
          _vm._v("周末"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "legend-item legend-item--disabled" }, [
          _c("i"),
          _vm._v("范围外"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }